import { Component, OnInit, ViewChild } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { COMMA, ENTER } from "@angular/cdk/keycodes";
import { NavParams, AlertController, LoadingController } from "@ionic/angular";
import { Storage } from "@ionic/storage";
import { AppService } from "../../../../app/services/app.service";
import { ApiserviceService } from "../../../../app/httpservice/apiservice.service";
import { MatChipInputEvent } from "@angular/material/chips";
import { CreditNoteService } from "../credit-node-service";
import { errMsg } from "../../../text_control/error-msg";
import { ADDRESS } from "../../../text_control/text_address";
import { BTN } from "../../../text_control/text_button";
import { _getStorage, _setStorage } from "../../../utils/local-storage";
import { STORAGE } from "../../../constant/storages";

export interface Phone {
  numbers: string;
}
@Component({
  selector: "app-credit-select-taxinvoice",
  templateUrl: "./credit-select-taxinvoice.component.html",
  styleUrls: ["./credit-select-taxinvoice.component.scss"],
})
export class CreditSelectTaxinvoiceComponent implements OnInit {
  public text_addr: any = {};
  public text_btn: any = {};
  reqBody: any;
  response: any;
  buyer_agree_tmp = "Y";
  buyer_branch_no: any = "";
  buyer_citizen_id = "";
  buyer_company_name = "";
  buyer_fname = "";
  buyer_main_branch_no;
  buyer_passpost_id = "";
  buyer_phone = "";
  buyer_sname = "";
  buyer_tax_id: any = "";
  branch_no = "";
  type_addr: any = "";
  addr_id = "";

  seller_id = null;
  room_no = "";
  floor = "";
  building_no = "";
  building_name = "";
  house_no = "";
  village_no = "";
  lane = "";
  road = "";
  sub_district = "";
  district = "";
  province = "";
  postcode = "";

  phone: any = "";
  email = "";
  address_status = "1";
  buyer_type = "";
  selectedDevice = "";
  showbranch1 = false;
  showbranch2 = true;
  addr_agree_tmp: any = "Y";
  showrefresh = false;
  showbtn2 = false;
  showContinue = false;
  showaddr = false;
  shownext = false;
  showedit = false;
  showsave = false;
  showback = false;
  isOldAbb: boolean = false;
  creditNoteLists: any = [];
  datasave: any = [];

  dataContinue: any;

  buyer_tax_id1 = "";
  buyer_branch_type = "";

  buyer_id: any;

  abb_no_ref: any = "";
  dataAddr: any = [];
  zipcode: any;
  isNewTaxInvoice: boolean = false;
  template_lang: any = "TH";
  buyer_status: any;

  dataCountry: any = [];
  country: any = "";
  dataCountrysearch: any = [];

  showTH = false;
  showEN = true;

  addrENCountry = "";
  addrENPostCode = "";
  addrENProvince = "";
  addrEN = "";
  addrENOther = "";

  showOther = false;
  redioaddress = "1";

  emailEN = "";
  telEN = "";
  itemEN: any;

  showcard = true;
  noshowcard = false;
  cardplaceholder = "";
  cardID = true;
  Active = 3;

  showperson1 = false;
  showperson2 = false;
  showperson3 = false;
  showperson = true;
  showfont = true;
  showname = false;
  showname1 = false;
  branch = false;

  dataProvince: any;
  groupAddress: any;
  groupProvince: any;
  isFindAddress = false;
  searchAddress = "";
  searchProvince = "";
  addressManual = false;

  showCompanyName = false;
  showTaxIDType = false;
  cardEvent = "";

  setparam = "";
  userID = "";
  userBu = "";
  userLoc = "";
  userRole = "";
  userSource = "";

  isAddress = false;
  addressline1 = "";

  constructor(
    public storage: Storage,
    public appservice: AppService,
    public apiservice: ApiserviceService,
    public alertController: AlertController,
    public router: Router,
    public loadingController: LoadingController,
    public cnService: CreditNoteService,
    private route: ActivatedRoute
  ) {
    this.userID = _getStorage(STORAGE.userID);
    this.userRole = _getStorage(STORAGE.userRole);
    this.userBu = _getStorage(STORAGE.userBu);
    this.userLoc = _getStorage(STORAGE.userLoc);
    this.userSource = _getStorage(STORAGE.SOURCE_SYSTEM);
    this.text_addr = ADDRESS;
    this.text_btn = BTN;

    this.appservice.cardEvent.subscribe((v) => {
      this.cardEvent = v;
      this.settingCard(v);
    });

    this.getParams();
  }
  async ngOnInit() {
    this.addressManual = false;
    this.groupAddress = this.appservice.address_thai;
    window.onclick = function (event) {
      var x = document.getElementById("showselect");
      var y = document.getElementById("notshowselect");
      var showprovince = document.getElementById("showSelectProvince");
      var notshowprovince = document.getElementById("notshowselectProvince");
      if (x !== null) {
        x.style.display = "none";
        y.style.display = "none";
      }
      if (showprovince !== null) {
        showprovince.style.display = "none";
        notshowprovince.style.display = "none";
      }
    };
    let groupData = [];
    this.groupAddress.forEach((v, i) => {
      const index = groupData.findIndex((f) => f.province === v.province);
      if (index === -1) {
        groupData = [...groupData, v];

        this.dataProvince = groupData;
      } else {
        return;
      }
    });
  }

  checkAddress(e) {
    console.log("checkAddress event =======:: ", e);
    this.isAddress = e.detail.checked;
  }

  filterAddress(e) {
    let val = e.target.value;
    if (val.trim() !== "") {
      this.groupAddress = this.appservice.address_thai.filter((item) => {
        return (
          String(item.zipcode).indexOf(val) > -1 ||
          item.province.indexOf(val) > -1 ||
          item.amphoe.indexOf(val) > -1 ||
          item.district.indexOf(val) > -1
        );
      });
      var x = document.getElementById("showselect");
      var y = document.getElementById("notshowselect");
      if (this.groupAddress.length > 0) {
        y.style.display = "none";
        if (x.style.display === "none") {
          x.style.display = "block";
        }
      } else {
        x.style.display = "none";
        if (y.style.display === "none") {
          y.style.display = "block";
        }
      }
    }
  }

  selectAddress(item) {
    this.sub_district = item.district;
    this.district = item.amphoe;
    this.province = item.province;
    this.postcode = item.zipcode;
    this.isFindAddress = false;
    this.searchAddress = "";
  }
  filterProvince(e) {
    let val = e.target.value;
    if (val.trim() !== "") {
      this.groupProvince = this.dataProvince.filter((item) => {
        return item.province.indexOf(val) > -1;
      });
      var x = document.getElementById("showSelectProvince");
      var y = document.getElementById("notshowselectProvince");
      if (this.groupAddress.length > 0) {
        y.style.display = "none";
        if (x.style.display === "none") {
          x.style.display = "block";
        }
      } else {
        x.style.display = "none";
        if (y.style.display === "none") {
          y.style.display = "block";
        }
      }
    }
  }
  selectProvince(item) {
    this.province = item.province;
    this.searchProvince = "";
  }
  clearAddress(name) {
    if (name === "Postcode") {
      this.postcode = "";
    }
    if (name === "Province") {
      this.province = "";
    }
    if (name === "District") {
      this.district = "";
    }
    if (name === "SubDistrict") {
      this.sub_district = "";
    }
  }

  checkProvince(event) {
    let province = this.appservice.address_thai.filter(
      (item) => item.province === event.target.value
    );
    console.log("event", event);
    if (province.length > 0) {
      setTimeout(() => {
        document.getElementById("inputEmail").focus();
      }, 1000);
    }
  }
  getParams() {
    this.route.queryParams.subscribe((params) => {
      this.datalist = params.datalist;
      if (params.updatecustomer === "updatecustomer") {
        this.setparam = params.updatecustomer;
        this.showedit = true;
        this.showaddr = true;
        this.showrefresh = false;
        this.shownext = true;
        this.showsave = false;
        this.showback = true;
      } else {
        this.showedit = false;
        this.showaddr = false;
        this.showrefresh = true;
        this.shownext = false;
        this.showsave = true;
        this.showback = true;
      }
    });
  }

  settingCard(v) {
    if (!this.isNewTaxInvoice) {
      this.showcard = false;
      this.noshowcard = true;
    }
    if (v === "0") {
      if (this.setparam === "updatecustomer") {
        this.showCompanyName = true;
        this.showTaxIDType = true;
      }
      this.buyer_type = "";
      this.cardID = false;
      this.showcard = false;
      this.noshowcard = true;
      this.showperson1 = true;
      this.showperson3 = false;
      this.showperson2 = false;
      this.showfont = false;
      this.showname = true;
      this.branch = false;
      this.buyer_tax_id1 = "";
      this.cardplaceholder = "";
    }
    if (v === "1") {
      this.showCompanyName = true;
      this.showTaxIDType = true;
      this.buyer_type = "0";
      this.showperson1 = true;
      this.showperson3 = false;
      this.showperson2 = false;
      this.showfont = false;
      this.showname = true;
      this.buyer_tax_id1 = "";
      this.noshowcard = false;
      this.showcard = true;
      this.branch = false;
      this.cardID = true;
      setTimeout(() => {
        document.getElementById("inputcompanyname").focus();
        this.cardplaceholder = "จุดเริ่มต้นเครื่องอ่านบัตร";
      }, 1);
    }
    this.getStorageData();
  }

  async getStorageData() {
    this.getParams();
    this.appservice.setActive(2);

    const loading = await this.apiservice.loading();
    loading.present();

    let indx = 0;
 
    indx = await _getStorage(STORAGE.viewDataIndx);
    console.log("indx====: ", indx);

    let res = await _getStorage(STORAGE.searchCreditNode);
    console.log("[getStorageData] res : ", res);
    this.reqBody = res.request;
    this.response = res.response;
    this.dataContinue = res;

    console.log("isOldAbb====: ", this.isOldAbb);
    console.log("this.datalist====: ", this.datalist);
    console.log(
      "_getStorage(STORAGE.listdataCreditnote)====: ",
      _getStorage(STORAGE.listdataCreditnote)
    );
    if (this.isOldAbb) {
      this.creditNoteLists = this.response.taxinvoice_list;
    } else {
      if (this.datalist === "datalist") {
        this.creditNoteLists = this.response.buyer_data;
      } else {
        this.creditNoteLists = this.response.buyer_data;
      }
    }

    this.dataAddr = this.response?.buyer_data[indx];
    let buyer = this.response?.buyer_data[indx];
    this.abb_no_ref = this.response?.abb_no_ref;

    if (this.response.buyer_data.length > 0) {
      this.isNewTaxInvoice = false;
      if (this.datalist === "datalist") {
        this.showedit = true;
        this.shownext = true;
        this.showContinue = false;
        this.isNewTaxInvoice = false;

        console.log("creditNoteLists======: ", this.creditNoteLists);
        this.buyer_id = this.creditNoteLists[indx].buyer_id;
        this.buyer_company_name = this.creditNoteLists[indx].buyer_company_name;
        this.buyer_main_branch_no =
          this.creditNoteLists[indx].buyer_main_branch_no;
        this.buyer_branch_no = this.creditNoteLists[indx].buyer_branch_no;
        this.buyer_citizen_id = this.creditNoteLists[indx].buyer_citizen_id;

        this.buyer_tax_id = this.creditNoteLists[indx].buyer_tax_id;
        this.buyer_tax_id1 = this.creditNoteLists[indx].buyer_tax_id;
        this.buyer_passpost_id = this.creditNoteLists[indx].buyer_passpost_id;
        this.buyer_agree_tmp = this.creditNoteLists[indx].buyer_agree_tmp;
        this.buyer_type = this.creditNoteLists[indx].buyer_type;
        this.template_lang = this.creditNoteLists[indx].template_lang;
        this.buyer_status = this.creditNoteLists[indx].buyer_status;

        if (this.buyer_type == "0") {
          this.showperson1 = true;
          this.showperson3 = false;
          this.showperson2 = false;
          this.showfont = false;
          this.showname = true;
          this.branch = false;
        } else if (this.buyer_type == "1") {
          this.showperson1 = false;
          this.showperson2 = true;
          this.showperson3 = false;
          this.showname1 = true;
          this.showfont = false;
          this.showname = false;
          this.branch = true;
        } else {
          this.showperson1 = false;
          this.showperson2 = false;
          this.showperson3 = true;
          this.showfont = false;
          this.showname = true;
          this.branch = false;
        }


        this.isAddress = this.creditNoteLists[indx].is_addresstxt;
        this.addressline1 = this.creditNoteLists[indx].addressline1;
        this.addr_id = this.creditNoteLists[indx].addr_id;
        this.building_no = this.creditNoteLists[indx].building_no;
        this.building_name = this.creditNoteLists[indx].building_name;
        this.house_no = this.creditNoteLists[indx].house_no;
        this.room_no = this.creditNoteLists[indx].room_no;
        this.floor = this.creditNoteLists[indx].floor;
        this.village_no = this.creditNoteLists[indx].village_no;
        this.lane = this.creditNoteLists[indx].lane;
        this.road = this.creditNoteLists[indx].road;
        this.phone =
          this.creditNoteLists[indx].phone.indexOf(",") > -1
            ? this.creditNoteLists[indx].phone.split(",")
            : [this.creditNoteLists[indx].phone];
        this.email = this.creditNoteLists[indx].email;
        this.address_status = this.creditNoteLists[indx].address_status;
        this.seller_id = this.creditNoteLists[indx].seller_id;
        this.addr_agree_tmp = this.creditNoteLists[indx].addr_agree_tmp;

        this.type_addr = this.creditNoteLists[indx].type_addr;
        this.itemEN = this.creditNoteLists[indx];
        // ============ START ADDRESS EN ============//

        let country: any;

        country = this.dataCountry.filter(
          (i) =>
            i.name.trim().toLowerCase() ===
            this.itemEN.inter_country.trim().toLowerCase()
        );
        if (country.length > 0) {
          this.addrENCountry = country[0].name + ":" + country[0].code;
        }

        this.addrENPostCode = this.itemEN.inter_postcode;
        this.addrENProvince = this.itemEN.inter_province;
        this.addrEN = this.itemEN.inter_address_line1;
        this.emailEN = this.itemEN.email;
        this.telEN = this.itemEN.inter_tel;

        // ============ START ADDRESS EN ============//
        if (this.itemEN.type_addr === "1") {
          this.redioaddress = "1";
          this.showTH = true;
          this.showEN = true;
        } else if (this.itemEN.type_addr === "2") {
          this.redioaddress = "2";
          this.showTH = true;
          this.showEN = true;
        }
        this.phones = [];
        this.phone = "";

        if (this.creditNoteLists[0].phone != "") {
          if (this.creditNoteLists[0].phone.indexOf(",") > -1) {
            this.creditNoteLists[0].phone.split(",").forEach((p) => {
              this.phones.push({ numbers: p });
            });
          } else {
            this.phones.push({
              numbers: this.creditNoteLists[0].phone,
            });
          }
        }
        this.postcode = this.creditNoteLists[0].postcode;
        this.buyer_branch_type =
          this.buyer_main_branch_no === "" ? "BRANCH" : "MAIN";
        this.province = this.creditNoteLists[0].province;
        this.district = this.creditNoteLists[0].district;
        this.sub_district = this.creditNoteLists[0].sub_district;

        await loading.dismiss();
      } else {
        this.buyer_id = buyer.buyer_id;
        this.buyer_company_name = buyer.buyer_company_name;
        this.buyer_main_branch_no = buyer.buyer_main_branch_no;
        this.buyer_branch_no = buyer.buyer_branch_no;
        this.buyer_citizen_id = buyer.buyer_citizen_id;

        console.log("[----this.reqbody cn_cid .......", this.reqBody.cn_cid);
        this.buyer_tax_id = this.reqBody.cn_cid;
        this.buyer_tax_id1 = this.reqBody.cn_cid;
        this.buyer_passpost_id = buyer.buyer_passpost_id;
        this.buyer_agree_tmp = buyer.buyer_agree_tmp;
        this.buyer_type = buyer.buyer_type;
        this.template_lang = buyer.template_lang;
        this.buyer_status = buyer.buyer_status;
        this.addr_id = buyer.addr_id;

        if (this.buyer_type == "0") {
          this.showperson1 = true;
          this.showperson3 = false;
          this.showperson2 = false;
          this.showfont = false;
          this.showname = true;
          this.branch = false;
        } else if (this.buyer_type == "1") {
          this.showperson1 = false;
          this.showperson2 = true;
          this.showperson3 = false;
          this.showname1 = true;
          this.showfont = false;
          this.showname = false;
          this.branch = true;
        } else {
          this.showperson1 = false;
          this.showperson2 = false;
          this.showperson3 = true;
          this.showfont = false;
          this.showname = true;
          this.branch = false;
        }

        this.isAddress = buyer.is_addresstxt;
        this.addressline1 = buyer.addressline1;
        this.building_no = buyer.building_no;
        this.building_name = buyer.building_name;
        this.house_no = buyer.house_no;
        this.room_no = buyer.room_no;
        this.floor = buyer.floor;
        this.village_no = buyer.village_no;
        this.lane = buyer.lane;
        this.road = buyer.road;
        this.phone =
          buyer.phone.indexOf(",") > -1
            ? buyer.phone.split(",")
            : [buyer.phone];
        this.email = buyer.email;
        this.address_status = buyer.address_status;
        this.seller_id = buyer.seller_id;
        this.addr_agree_tmp = buyer.addr_agree_tmp;

        this.type_addr = buyer.type_addr;
        this.itemEN = buyer;
        // ============ START ADDRESS EN ============//

        let country: any;

        country = this.dataCountry.filter(
          (i) =>
            i.name.trim().toLowerCase() ===
            this.itemEN.inter_country.trim().toLowerCase()
        );
        if (country.length > 0) {
          this.addrENCountry = country[0].name + ":" + country[0].code;
        }

        this.addrENPostCode = this.itemEN.inter_postcode;
        this.addrENProvince = this.itemEN.inter_province;
        this.addrEN = this.itemEN.inter_address_line1;
        this.emailEN = this.itemEN.email;
        this.telEN = this.itemEN.inter_tel;

        // ============ START ADDRESS EN ============//
        if (this.itemEN.type_addr === "1") {
          this.redioaddress = "1";
          this.showTH = true;
          this.showEN = true;
        } else if (this.itemEN.type_addr === "2") {
          this.redioaddress = "2";
          this.showTH = true;
          this.showEN = true;
        }
        this.phones = [];
        this.phone = "";

        if (buyer.phone != "") {
          if (buyer.phone.indexOf(",") > -1) {
            buyer.phone.split(",").forEach((p) => {
              this.phones.push({ numbers: p });
            });
          } else {
            this.phones.push({ numbers: buyer.phone });
          }
        }
        this.postcode = buyer.postcode;
        this.buyer_branch_type =
          this.buyer_main_branch_no == "" ? "BRANCH" : "MAIN";
        this.province = buyer.province;
        this.district = buyer.district;
        this.sub_district = buyer.sub_district;

        this.getParams();
        loading.dismiss();
      }
    } else {
      this.showrefresh = true;
      this.showsave = true;
      this.showback = true;
      this.showedit = false;
      this.showContinue = false;
      this.shownext = false;
      this.isNewTaxInvoice = true;
      this.buyer_tax_id = this.reqBody.cn_cid.match(/[0-9]*/)[0];
      this.buyer_tax_id1 = this.reqBody.cn_cid;
    }
    loading.dismiss();
  }

  async ErrorMsg(message: string) {
    let alert = await this.alertController.create({
      cssClass: "my-custom-class",
      message: message,
      buttons: [
        {
          text: "OK",
          cssClass: "alertButton",
          handler: (blah) => {
            //
          },
        },
      ],
    });
    await alert.present();
  }

  datalist: any = [];

  checkbranch1() {
    this.showbranch2 = true;
    this.branch_no = "";
  }
  checkbranch2() {
    this.showbranch2 = false;
  }
  checkPostcodeEN(e) {
    this.addrENPostCode = e.target.value.match(/[0-9]*/)[0];
  }
  checkpostcode(e) {
    this.postcode = e.target.value.match(/[0-9]*/)[0];
  }

  checktype(e, n) {
    if (n === 1) {
      this.showCompanyName = true;
      this.showTaxIDType = true;

      this.showperson1 = true;
      this.showperson3 = false;
      this.showperson2 = false;
      this.showfont = false;
      this.showname = true;
      this.branch = false;
      this.buyer_main_branch_no = "00000";
      if (this.cardEvent === "0") {
        this.showcard = false;
        this.noshowcard = true;
      } else {
        this.showcard = true;
        this.noshowcard = false;
        setTimeout(() => {
          document.getElementById("inputcompanyname").focus();
          this.cardplaceholder = "จุดเริ่มต้นเครื่องอ่านบัตร";
        }, 100);
      }
    }
    if (n === 2) {
      this.showCompanyName = true;
      this.showTaxIDType = true;
      this.noshowcard = true;
      this.showcard = false;
      this.showperson1 = false;
      this.showperson2 = true;
      this.showperson3 = false;
      this.showname1 = true;
      this.showfont = false;
      this.showname = false;
      this.branch = true;
      this.buyer_main_branch_no = "00000";
      this.buyer_branch_type = "MAIN";
    }
    if (n === 3) {
      this.showCompanyName = true;
      this.showTaxIDType = true;
      this.showcard = false;
      this.noshowcard = true;
      this.showperson1 = false;
      this.showperson2 = false;
      this.showperson3 = true;
      this.showfont = false;
      this.showname = true;
      this.branch = false;
      this.buyer_main_branch_no = "00000";
    }
  }

  checkinput1(e) {
    this.buyer_tax_id = e.target.value.match(/[0-9]*/)[0];
  }
  checkTaxID1(e) {
    this.buyer_tax_id1 = e.target.value.match(/[0-9a-zA-Z]*/)[0];
  }
  creditcard_num: any;
  checkbranch(e, n) {
    console.log("[----event---]", e.target.value);
    let branch = [];
    let checknumber = "";
    let checkevent = "";
    checkevent = e.target.value;
    if (n == 1) {
      if (isNaN(this.buyer_branch_no) || e.key == " ") {
        this.buyer_branch_no = this.buyer_branch_no.slice(0, -1);
      }
      if (checkevent.length > 5) {
        this.buyer_branch_no = e.target.value.slice(0, -1);
        this.branch_no = this.buyer_branch_no;
        console.log("tmp_val2", this.buyer_branch_no);
      } else if (checkevent.length < 5) {
        let input_val = "";
        for (let i = 0; i < 5; i++) {
          input_val += "0";
          checknumber = input_val.slice(0, -checkevent.length) + checkevent;
        }
        this.branch_no = checknumber;
      }
    }
  }

  async savedata() {
    let isConfirm: boolean = false;
    let buyer_tax_id = String(this.buyer_tax_id);
    let house_no = String(this.house_no);
    let province: any;
    let district: any;
    let sub_district: any;

    if (this.branch_no != "") {
      this.buyer_main_branch_no = "";
    }

    let phones = [];

    console.log("this.phone : ", this.phones);
    for (let i of this.phones) {
      phones.push(i.numbers);
    }
    if (this.showcard === true) {
      province = this.province;
      district = this.district;
      sub_district = this.sub_district;
    }
    if (this.noshowcard === true) {
      province = this.province;
      district = this.district;
      sub_district = this.sub_district;
    }
    console.log("phone", phones);

    if (this.redioaddress === "1") {
      let filterPostcode = this.groupAddress.filter(
        (f) => f.zipcode === Number(this.postcode)
      );
      let filterProvince = this.groupAddress.filter(
        (f) => f.province === this.province
      );
      if (!isConfirm) {
        if (this.buyer_type === "") return this.ErrorMsg(errMsg.buyer_type);
        if (this.buyer_company_name === "")
          return this.ErrorMsg(errMsg.buyer_company_name);
        if (this.buyer_type !== "2" && buyer_tax_id.length !== 13)
          return this.ErrorMsg(errMsg.buyer_tax_id);
        if (
          this.buyer_type !== "2" &&
          !this.appservice.checkIdentityCardNumber(buyer_tax_id)
        )
          return this.ErrorMsg(errMsg.card_tax);
        if (this.buyer_type === "2" && this.buyer_tax_id1.trim() === "")
          return this.ErrorMsg(errMsg.buyer_tax_id1);
        if (this.buyer_type === "1" && this.buyer_branch_type === undefined)
          return this.ErrorMsg(errMsg.buyer_main_branch_no);
        if (
          this.buyer_type === "1" &&
          this.buyer_branch_type === "BRANCH" &&
          this.buyer_branch_no === ""
        )
          return this.ErrorMsg(errMsg.buyer_branch_no);

        if (this.buyer_type == "2" && this.buyer_tax_id1.trim() == "")
          return errMsg.buyer_tax_id1;
        if (
          this.buyer_main_branch_no === "11111" &&
          this.buyer_branch_no === ""
        )
          return this.ErrorMsg(errMsg.buyer_main_branch_no);

        if (this.isAddress === true && this.addressline1 === "")
          return this.ErrorMsg(errMsg.errorAddressline1);

        if (this.isAddress === true && this.postcode === "") {
          return this.ErrorMsg(errMsg.postcode);
        }
        if (this.isAddress === false) {
          if (house_no === "") return this.ErrorMsg(errMsg.house_no);
          if (this.postcode === "") return this.ErrorMsg(errMsg.postcode);
          if (this.postcode !== "" && filterPostcode.length === 0)
            return this.ErrorMsg(errMsg.notpostcode);
          if (district === "") return this.ErrorMsg(errMsg.district);
          if (sub_district === "") return this.ErrorMsg(errMsg.sub_district);
          if (province === "") return this.ErrorMsg(errMsg.province);
          if (province !== "" && filterProvince.length === 0)
            return this.ErrorMsg(errMsg.notprovince);
        }

        if (this.buyer_agree_tmp === undefined)
          return this.ErrorMsg(errMsg.buyer_agree_tmp);
        if (this.template_lang === undefined)
          return this.ErrorMsg(errMsg.template_lang);
        if (this.email !== "") {
          const re =
            /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          if (!re.test(this.email)) {
            return this.ErrorMsg("รูปแบบ email ไม่ถูกต้อง");
          } else {
            isConfirm = true;
          }
        }
        isConfirm = true;
      }
    } else {
      if (!isConfirm) {
        if (this.buyer_type === "") return this.ErrorMsg(errMsg.buyer_type);
        if (this.buyer_company_name === "")
          return this.ErrorMsg(errMsg.buyer_company_name);
        if (this.buyer_type !== "2" && buyer_tax_id.length !== 13)
          return this.ErrorMsg(errMsg.buyer_tax_id);
        if (
          this.buyer_type !== "2" &&
          !this.appservice.checkIdentityCardNumber(buyer_tax_id)
        )
          return this.ErrorMsg(errMsg.card_tax);
        if (this.buyer_type === "2" && this.buyer_tax_id1.trim() === "")
          return this.ErrorMsg(errMsg.buyer_tax_id1);
        if (this.buyer_type === "1" && this.buyer_branch_type === undefined)
          return this.ErrorMsg(errMsg.buyer_main_branch_no);
        if (
          this.buyer_type === "1" &&
          this.buyer_branch_type === "BRANCH" &&
          this.buyer_branch_no === ""
        )
          return this.ErrorMsg(errMsg.buyer_branch_no);

        if (this.addrENProvince === "" || this.addrENProvince === undefined)
          return this.ErrorMsg(errMsg.addrENProvince);

        if (this.addrENPostCode === "" || this.addrENPostCode === undefined)
          return this.ErrorMsg(errMsg.addrENPostCode);

        if (this.addrENCountry === "" || this.addrENCountry === undefined)
          return this.ErrorMsg(errMsg.addrENCountry);
        if (this.email != "") {
          const re =
            /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          if (!re.test(this.email)) {
            return this.ErrorMsg("รูปแบบ email ไม่ถูกต้อง");
          } else {
            isConfirm = true;
          }
        }
        isConfirm = true;
        isConfirm = true;
      }
    }

    if (isConfirm) {
      if (this.buyer_tax_id === "") {
        this.buyer_tax_id = this.buyer_tax_id1;
      }
      let req: any;
      const data = {
        buyer_company_name: this.buyer_company_name,
        buyer_people_id: "",
        buyer_main_branch_no:
          this.buyer_type != "1" ? "" : this.buyer_main_branch_no,
        buyer_branch_no:
          this.buyer_type != "1"
            ? ""
            : this.buyer_main_branch_no == "00000"
            ? ""
            : this.buyer_branch_no.padStart(5, "0"),
        buyer_citizen_id: this.buyer_citizen_id,
        buyer_tax_id:
          this.buyer_type == "2" ? this.buyer_tax_id1 : this.buyer_tax_id,
        buyer_type: this.buyer_type,
        buyer_passpost_id: this.buyer_passpost_id,
        buyer_agree_tmp: this.buyer_agree_tmp, // ===>>> key tmp [ ยินยอม Y / ไม่ยินยอม N]
        user_id: this.userID,
        buyer_status: this.buyer_status === undefined ? "" : this.buyer_status,
        template_lang: this.template_lang,
        address_detail: {
          building_no: this.building_no,
          building_name: this.building_name,
          room_no: this.room_no,
          floor: this.floor,
          house_no: this.house_no,
          village_no: this.village_no,
          lane: this.lane,
          road: this.road,
          sub_district: sub_district,
          district: district,
          province: province,
          postcode: String(this.postcode),
          phone: phones.join(","),
          email: this.email === undefined ? "" : this.email,
          address_status: this.address_status,
          addr_agree_tmp: this.buyer_agree_tmp,
          seller_id: "",
          buyer_id: "", //condition
          user_id: this.userID,
          type_addr: this.redioaddress,
          inter_address_line1: this.addrEN,
          inter_country: this.addrENCountry,
          inter_fax: "",
          inter_postcode: this.addrENPostCode,
          inter_province: this.addrENProvince,
          inter_tel: this.telEN,
          is_addresstxt: this.isAddress,
          addressline1: this.addressline1 || "",
        },
      };
      if (this.isNewTaxInvoice) {
        req = {
          newCustomerData: data,
        };
      } else {
        data["buyer_id"] = this.buyer_id;
        data.address_detail.buyer_id = this.buyer_id;
        data.address_detail["addr_id"] = this.addr_id;
        req = {
          updateCustomerData: data,
        };
      }

      console.log("======== req update customer ==========", req);

      try {
        this.apiservice
          ._post(this.apiservice.apiUrl + this.apiservice.updateCustomer, req)
          .then(async (res: any) => {
            console.log("======== res updatecustomer ============", res);
            this.datasave = res.data;

            if (res.statusCode === 200) {
              console.log("this.datasave====: ", this.datasave);
              let setdata = this.cnService.setTaxinvoiceList(this.datasave);
              console.log("setdata====: ", setdata);
              _setStorage(STORAGE.verifyCreditNote, setdata);
              const alert = await this.alertController.create({
                cssClass: "my-custom-class",
                message: "บันทึกข้อมูลเรียบร้อย",
                buttons: [
                  {
                    text: "OK",
                    cssClass: "alertButton",
                    handler: (blah) => {
                      console.log("Confirm Cancel: blah");
                      this.showContinue = true;
                      this.showback = false;
                      this.showsave = false;
                      this.showrefresh = false;
                      this.showbtn2 = false;
                      this.showaddr = false;
                      this.shownext = false;
                      this.showedit = false;
                    },
                  },
                ],
              });
              await alert.present();
            } else {
              this.ErrorMsg(res.statusMessage);
            }
          });
      } catch (error) {
        // this.ErrorMsg(errMsg.error);
      }
    }
  }

  getDate() {
    let d = new Date();
    return d.getDate() + "/" + (d.getMonth() + 1) + "/" + d.getFullYear();
  }

  checkphone(e) {
    this.phone = e.target.value.match(/[0-9]*/)[0];
  }
  checkphoneEN(e) {
    this.telEN = e.target.value.match(/[0-9]*/)[0];
  }
  visible = true;
  selectable = true;
  removable = true;
  addOnBlur = true;
  readonly separatorKeysCodes: number[] = [ENTER, COMMA];
  phones: Phone[] = [];

  add(e: MatChipInputEvent, n): void {
    const input = e.input;
    const value = e.value;

    // Add our fruit
    if ((value || "").trim()) {
      console.log("value : ", value);
      this.phones.push({ numbers: value.trim() });
    }

    // Reset the input value
    if (input) {
      input.value = "";
    }
  }

  remove(p: Phone): void {
    const index = this.phones.indexOf(p);

    if (index >= 0) {
      this.phones.splice(index, 1);
    }
  }

  goBackPage() {
    if (this.Active === 3) {
      if (this.datalist === "datalist") {
        this.router.navigate(["/credit-note-tax-list"], {
          queryParams: { datalist: "datalist" },
        });
      } else {
        this.router.navigate(["/credit-note-tax-list"]);
      }
    } else {
      this.router.navigate(["/credit-note-tax-list"], {
        queryParams: { noName: "no_cn", selectedIndex: "4" },
      });
    }
  }
  checkemail(e) {
    this.email = e.target.value.match(/[0-9a-z._@A-Z- ]*/)[0];
  }
  checkemailEN(e) {
    this.email = e.target.value.match(/[0-9a-z._@A-Z- ]*/)[0];
  }

  checkaddressTH() {
    this.template_lang = "TH";
    this.showTH = false;
    this.showEN = true;
  }
  checkaddressEN() {
    this.template_lang = "EN";
    this.showTH = true;
    this.showEN = false;
  }

  checkaddrENOther() {
    this.showOther = this.addrENCountry !== "Other" ? false : true;
  }

  searchaddrEN(search) {
    let val: string = search;
    if (val.trim() !== "") {
      this.dataCountry = this.dataCountrysearch.filter((item) => {
        return item.name.toLowerCase().indexOf(val.toLowerCase()) > -1;
      });
    }

    if (val === "") {
      this.reloadcountry();
    }
  }
  reloadcountry() {
    // this.addrENCountry = this.appService.Country[0]
    this.dataCountry = this.appservice.Country;
    this.dataCountrysearch = this.appservice.Country;
  }

  async ionViewDidEnter() {
    console.log(
      "_getStorage(STORAGE.listdataCreditnote)====: ",
      _getStorage(STORAGE.listdataCreditnote)
    );

    this.route.queryParams.subscribe((params) => {
      if (params.noName === "no_cn") {
        this.Active = Number(params.selectedIndex);
      } else {
        this.Active = 3;
      }
    });

    var showprovince = document.getElementById("showSelectProvince");
    var notshowprovince = document.getElementById("notshowselectProvince");

    if (showprovince !== null) {
      showprovince.style.display = "none";
      notshowprovince.style.display = "none";
    }
    this.buyer_agree_tmp = "Y";
    this.buyer_branch_no = "";
    this.buyer_citizen_id = "";
    this.buyer_company_name = "";
    this.buyer_fname = "";
    this.buyer_main_branch_no;
    this.buyer_passpost_id = "";
    this.buyer_phone = "";
    this.buyer_sname = "";
    this.buyer_tax_id = "";
    this.branch_no = "";
    this.type_addr = "";

    this.seller_id = null;
    this.building_no = "";
    this.building_name = "";
    this.house_no = "";
    this.village_no = "";
    this.lane = "";
    this.road = "";
    this.sub_district = "";
    this.district = "";

    this.province = "";
    this.postcode = "";
    this.phone = "";
    this.email = "";
    this.address_status = "1";
    this.buyer_type = "";
    this.selectedDevice = "";

    this.showbranch1 = false;
    this.showbranch2 = true;
    this.addr_agree_tmp = "Y";
    this.district = "";
    this.buyer_tax_id1 = "";
    this.buyer_branch_type = "";
    this.room_no = "";
    this.floor = "";
    this.buyer_id = "";
    this.abb_no_ref = "";
    this.dataAddr = [];
    this.zipcode = "";
    this.isNewTaxInvoice = false;
    this.template_lang = "TH";
    this.buyer_status = "";
    this.dataCountry = [];
    this.country = "";
    this.dataCountrysearch = [];

    this.showTH = false;
    this.showEN = true;

    this.addrENCountry = "";
    this.addrENPostCode = "";
    this.addrENProvince = "";
    this.addrEN = "";
    this.addrENOther = "";

    this.showOther = false;
    this.redioaddress = "1";

    this.emailEN = "";
    this.telEN = "";
    this.itemEN = "";

    this.showcard = true;
    this.noshowcard = false;
    this.cardplaceholder = "";
    this.cardID = true;
    this.visible = true;
    this.selectable = true;
    this.removable = true;
    this.addOnBlur = true;
    this.phones = [];

    this.isFindAddress = false;
    this.searchAddress = "";
    this.searchProvince = "";
    this.addressManual = false;

    window.localStorage.pageName = "CreditSelectTaxinvoiceComponent";
    this.appservice.setActive(2);
    const v = _getStorage(STORAGE.DATA_CARDID);
    this.cardEvent = v;
    this.settingCard(v);
    await this.reloadcountry();
    await this.getStorageData();
  }

  async Continue() {
    let setdata = await this.cnService.setTaxinvoiceList(this.datasave);
    console.log("continue setdata ====: ", setdata);
    _setStorage(STORAGE.verifyCreditNote, setdata);
    _setStorage(STORAGE.listdataCreditnote, this.datasave);
    this.router.navigate(["/credit-check-taxinvoice"]);
  }

  async setnextstorage() {
    const res = _getStorage(STORAGE.viewDataIndx);
    console.log("=======view data index =======", res);

    if (res != null) {
      let verifyData: any;

      if (!this.isOldAbb) {
        verifyData = await this.cnService.setTaxinvoiceList([
          this.creditNoteLists[res],
        ]);
      } else {
        verifyData = this.creditNoteLists[res];
      }

      _setStorage(STORAGE.verifyCreditNote, verifyData);
      this.router.navigate(["/credit-check-taxinvoice"]);
    } else {
      let setdata = await this.cnService.setTaxinvoiceList(this.datasave);
      _setStorage(STORAGE.verifyCreditNote, setdata);
      this.router.navigate(["/credit-check-taxinvoice"]);
    }
  }
  editdata() {
    this.showedit = false;
    this.showaddr = false;
    this.showsave = true;
    this.shownext = false;
    if (this.itemEN.type_addr === "1") {
      this.redioaddress = "1";
      this.showTH = false;
      this.showEN = true;
    } else if (this.itemEN.type_addr === "2") {
      this.redioaddress = "2";
      this.showTH = true;
      this.showEN = false;
    }
  }
}
